//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BannerLeft from '~/static/roadblocks/banner-left.svg';
import BannerRight from '~/static/roadblocks/banner-right.svg';
import AppSumoLogo from '~/static/roadblocks/appsumo-logo.svg?inline';

export default {
  components: { AppSumoLogo },

  data() {
    return {
      BannerLeft,
      BannerRight,
      utmParams: '',
    };
  },

  mounted() {
    this.utmParams = new URLSearchParams({
      utm_source: this.$cookies.get('utm_source') || 'as-site',
      utm_campaign: this.$cookies.get('utm_campaign') || 'bf-fund-submit',
      utm_medium: this.$cookies.get('utm_medium') || 'bf-fund',
    }).toString();
  },
};
